import * as React from 'react'
import { SVGProps } from 'react'
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.5 15.833V6.667A5.833 5.833 0 0 0 11.667.833H8.333a2.5 2.5 0 0 0-2.5 2.5v0m9.167 15V9.167c0-1.708 0-2.562-.256-3.243a4 4 0 0 0-2.335-2.334c-.681-.257-1.535-.257-3.242-.257v0c-1.708 0-2.562 0-3.243.257A4 4 0 0 0 3.59 5.924c-.257.681-.257 1.535-.257 3.243v9.166l1.07-.611c1.737-.992 2.605-1.488 3.527-1.683a6 6 0 0 1 2.474 0c.921.195 1.79.69 3.526 1.683l1.07.611Z"
    />
  </svg>
)
export default SvgComponent
